import type { KnowledgeRequirement } from "./types";

// Single definition of "which pack requirements count as reviewable Spark Guides" —
// shared by the pre-install gate (TemplatesPage) and the pre-run gate (ScribeFab).
export const filterReviewableRequirements = (requirements: KnowledgeRequirement[]): KnowledgeRequirement[] =>
	(requirements || []).filter((requirement) => requirement.knowledgeType === "table" || requirement.knowledgeType === "document");
